module.exports = __webpack_public_path__ + "img/reset-password-v2-dark.9ce372df.svg";